import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import y from 'y4/Utils';
import _ from 'lodash';
import MainContentCard from './MainContentCard';
import AdvanceGrid from './grid/AdvanceGrid';
import BasicGrid from './grid/BasicGrid';
import EditGrid from './grid/EditGrid';
import PagingGrid from './grid/PagingGrid';
import EmbedPage from './static/EmbedPage';
import HtmlPanel from './static/HtmlPanel';
import ButtonPanel from './static/ButtonPanel';
import EChartsPanel from './chart/EChartsPanel';
import ChartJSPanel from './chart/ChartJSPanel';
import FormPanel from './form/FormPanel';
import BasicListPanel from './list/BasicListPanel';
import SingleFilter from './filter/SingleFilter';

const MainContentPanel = ({ form, panel }) => {
  //Create EventTarget form all panels
  if (!form.eventTarget) form.eventTarget = new EventTarget();

  useEffect(() => {
    y.setNavbarTopBadges('form-\\.*'); //remove all form badges
    y.setNavbarTopSearchBox(null); //hidden search box
  }, []);

  if (panel) {
    if (panel.type === 'AdvanceGrid') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <AdvanceGrid form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'BasicGrid') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <BasicGrid form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'ECharts') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <EChartsPanel form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'ChartJS') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <ChartJSPanel form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'EmbedPage') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <EmbedPage form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'Form') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <FormPanel form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'Html') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <HtmlPanel form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'BasicList') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <BasicListPanel form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'EditGrid') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <EditGrid form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'PagingGrid') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <PagingGrid form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'SingleFilter') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <SingleFilter form={form} panel={panel} />
        </MainContentCard>
      );
    } else if (panel.type === 'ButtonPanel') {
      return (
        <MainContentCard
          title={_.get(panel, 'option.title')}
          header={_.get(panel, 'option.header')}
          footer={_.get(panel, 'option.footer')}
          attributes={_.get(panel, 'option.attributes')}
          bodyAttributes={_.get(panel, 'option.bodyAttributes')}
        >
          <ButtonPanel form={form} panel={panel} />
        </MainContentCard>
      );
    } else {
      return (
        <MainContentCard title="Unsupported" attributes={{ bg: 'danger' }}>
          Unsupported panel type: {panel.type}
        </MainContentCard>
      );
    }
  } else {
    return (
      <MainContentCard title="No panel" attributes={{ bg: 'danger' }}>
        There is no panel object.
      </MainContentCard>
    );
  }
};

MainContentPanel.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object
};

export default MainContentPanel;
